<template>
    <div v-if="visible">
        <v-dialog
            v-model="dialog"
            persistent
            max-width="600"
        >
            <v-card>
                <v-card-title class="px-3">Client Log</v-card-title>
                <v-divider></v-divider>

                <v-data-table
                        v-if="clientLog"
                        :headers="headers"
                        :items="clientLogRev"
                        class="elevation-0"
                        :items-per-page="5"
                >
                    <template v-slot:item.createdAt="{ item }">
                        <v-icon small :color="item.iconColour" size="22" class="mr-2">
                            {{ item.icon }}
                        </v-icon>
                        {{ item.createdAt }}
                    </template>
                    <template v-slot:item.userId="{ item }">
                        <span v-if="item.created_by != null">
                            {{ `${item.created_by.first_name} ${item.created_by.surname}` }}
                        </span>
                        <span v-else>
                            SYSTEM
                        </span>
                    </template>
                </v-data-table>

                <v-divider class="mt-2"></v-divider>
                <v-col md="12" class="pt-5">
                    
                    <v-text-field
                        v-model="note"
                        label="Add New Note"
                        class="pt-0"
                    ></v-text-field>
                </v-col>

                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="error" @click="$emit('close', false);">Close</v-btn>
                    <v-btn color="primary" @click="addNote">Add Note</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import axios from 'axios';

export default {
    props: {
        visible: Boolean,
        clientLog: Array
    },
    data() {
        return {
            headers: [{ text: 'Date', value: 'createdAt', sortable: false, align: 'left' },
                      { text: 'User', value: 'userId', sortable: false, align: 'left' },
                      { text: 'Note', value: 'desc', sortable: false, align: 'left' }],
            note: null
        }
    },
    computed: {
        dialog() {
            return this.visible ? true : false;
        },
        clientLogRev() {
            return this.clientLog.slice().reverse();
        }
    },
    methods: {
        addNote(){
            axios({
                method: 'post',
                url: 'add-note',
                data: { note: this.note, clientId: this.$route.params.id, userId: this.$store.state.user.id },
                config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
                })
                .then(response => {
                    console.log(response.data);
                    this.note = null;
                    this.$emit('getClientLog');
                })
                .catch(e => {
                    this.errors.push(e)
            })
        }
    }
}
</script>

<style>

</style>